import {DataListModel} from './data-list.model';
import {MarketingItemModel} from './marketing-item.model';

export class MarketingItemsModel extends DataListModel {
  items: MarketingItemModel[] = [];
}
